import { FIELDS } from "./fields"

export const CATEGORY_TABLE_COLUMNS = [
    { id: FIELDS.name.key, label: FIELDS.name.name },
    { id: FIELDS.taxPlan.key, label: FIELDS.taxPlan.name },
]

export const SPECIAL_CATEGORY_IDS = [0]